// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"93":"b07fc02f","264":"483d9c78","565":"00b97184","971":"16504a4a","973":"b2bd202a"}[chunkId] + ".css";
};